import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { motion, AnimatePresence } from 'framer-motion';

/* Icons */
import ArrowIcon from '~/../symbols/arrow.svg';
import ChevRonIcon from '~/../symbols/chevron.svg';

/* Common */
import { Icon } from '~/components/common';

/* Constants */
import { scaleOutIn } from '~/constants/animations'

export default function Button({
    className = '',
    theme,
    href,
    title,
    showTitle = true,
    target,
    attributes,
    showIcon = true,
    icon = withCircle ? ChevRonIcon : ArrowIcon,
    iconClassName = '',
    iconType,
    iconTheme,
    iconSize = withCircle ? 20 : 16,
    onClick,
    disabled = false,
    loading = false,
    loadingSize = iconSize,
    loadingTheme,
    textClassName = '',
    withCircle = false
}) {
    const Tag = href ? 'a' : 'button';
    const linkAttributes = href ? { href, target, rel: target == '_blank' ? 'noreferrer noopener' : '' } : {};

    if (withCircle) {
        iconSize = 0;
    }

    return (
        <Tag
            className={`btn ${theme && !withCircle ? `btn-${theme}` : `btn--with-circle btn--with-circle-${theme}`} ${className}`}
            {...linkAttributes}
            disabled={disabled}
            {...attributes}
            {...{ title, onClick }}
        >
            {showIcon && (
                <AnimatePresence initial={false} exitBeforeEnter>
                    {loading ?
                        (
                            <motion.div key="loading" {...scaleOutIn} className={`btn__icon-wrapper ${loadingSize ? `loading--${loadingSize}` : ''}`}>
                                <CircularProgress
                                    classes={{
                                        root: `loading loading--circular ${loadingSize ? `loading--${loadingSize}` : ''} ${loadingTheme ? `text-${loadingTheme}` : ''}`,
                                    }}
                                />
                            </motion.div>
                        )
                        :
                        (
                            <motion.div key="icon" {...scaleOutIn} className="btn__icon-wrapper">
                                <Icon
                                    type={iconType}
                                    theme={iconTheme}
                                    size={iconSize}
                                    className={`btn__icon ${withCircle ? 'icon--circle' : ''} ${iconClassName}`}
                                    url={icon?.url}
                                />
                            </motion.div>
                        )
                    }
                </AnimatePresence>

            )}
            {showTitle && title && (
                <span className={`btn__text ${textClassName}`}>{title}</span>
            )}
        </Tag>
    );
}
